import axios from 'axios'
import httpInterceptor from '@/setup/httpInterceptor';
import Vue from "vue";

// Axios
axios.defaults.withCredentials = (process.env.VUE_APP_API_CREDENTIALS === 'true');
axios.defaults.baseURL         = process.env.VUE_APP_API_URL;
Vue.prototype.$http            = axios;
httpInterceptor();
